<template>
  <div class="intro">
    <div class="intro-content">
      <h1 class="heading heading--primary">Let's Get This Party Started</h1>
      <p
        class="intro-content__body"
      >Just select a speaker part and start playing. You can add custom text, custom colors, even custom fabric. In no time you’ll have your very own creation.</p>
    </div>
    <div class="product">
      <div class="product__links">
        <router-link
          :to="{ name: 'Fabric' }"
          class="btn btn--full-width btn--right btn--inverse m-b-sm"
          data-text="Get Started"
        >Get Started</router-link>
      </div>
      <img src="/images/custom-mobile.jpg" alt class="product__img">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';
import Button from "@/components/Button.vue";

export default {
  name: "introduction",
  components: { Button },
  mounted() {
    document.querySelector("html").classList.add("full-page");
  }
};
</script>
<style lang="scss" scoped>
@import "../scss/variables";
.m-b-sm {
  margin-bottom: 0.5em;
}
.m-b-md {
  margin-bottom: 1.5em;
}
strong {
  font-weight: bold;
}
.heading {
  font-size: 2em;
  text-align: center;
  margin-bottom: 0.5em;
  @media (min-width: 992px) {
    text-align: left;
    font-size: 3em;
  }
  &--primary {
    text-transform: uppercase;
  }
  &__em {
    font-size: 1.5em;
    display: block;
  }
}
.intro {
  background: #fff;
  padding-top: 95px;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  height: 100%;
  position: relative;
  overflow: hidden;
  @media (min-width: 992px) {
    display: flex;
    padding-top: 2em;
    padding-left: 1.5em;
    padding-right: 1.5em;
    align-items: center;
    justify-content: flex-start;
    // height: 100vh;
  }
}
.intro-content {
  padding: 0 2em;
  @media (min-width: 992px) {
    width: 100%;
    max-width: 350px;
    margin-right: 5em;
  }
  &__body {
    font-size: 0.9em;
    color: $greyDark;
    font-family: sans-serif;
    line-height: 1.3;
    max-width: 260px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 1.5em;
    @media (min-width: 600px) {
      max-width: 400px;
    }
    @media (min-width: 992px) {
      text-align: left;
      margin-left: 0;
      max-width: none;
      color: #000;
      font-size: 1em;
      max-width: 350px;
    }
  }
  &__faq {
    color: #000;
    font-weight: bold;
    text-decoration: none;
    line-height: 1.5;
    border-bottom: 3px solid #000;
    text-transform: uppercase;
    font-size: 0.85em;
    display: none;
    @media (min-width: 992px) {
      display: block;
    }
  }
  &__links {
    display: none;
    @media (min-width: 600px) {
      display: flex;
      justify-content: center;
    }
    @media (max-width: 991px) {
      .btn--home {
        /* reset to normal button styles for tablet */
        border: 4px solid #000;
        background-image: none;
        padding: 0.9rem 1.3rem;

        &.btn--inverse {
          background-color: black;
          color: white;
        }
        &:first-child {
          margin-right: 1em;
        }
      }
    }
    @media (min-width: 992px) {
      .btn--home {
        margin-bottom: 1em;
      }
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
.faq {
  background-color: $greyDark;
  color: #fff;
  text-decoration: none;
  display: block;
  text-align: center;
  text-transform: uppercase;
  padding: 1.25em 1.25em 1.5em;
  font-weight: bold;

  span {
    border-bottom: 3px solid currentColor;
  }
  @media (min-width: 992px) {
    display: none;
  }
}
.product {
  overflow: hidden;
  margin-top: 2em;
  bottom: 0;
  max-width: 515px;
  margin-left: auto;
  margin-right: auto;
  &__img {
    width: 75%;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  //   @media (min-width: 992px) {
  //     align-self: flex-end;
  //   }
  &__links {
    position: absolute;
    bottom: 100px;
    text-align: center;
    left: 0;
    right: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    max-width: 60%;
    min-width: 200px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>